import i18n from '@/i18n'
import forEach from 'lodash/forEach'
export const errorMap = {
  40010012: i18n.t('ded158d9dc'),
  40100001: i18n.t('11377326ac'),
  40000201: i18n.t('321495498a'),
  40010005: i18n.t('6728034eac'),
  50000001: i18n.t('c1c0c3ef49'),
  50010006: i18n.t('c2c0c5ef78'),
  40010002: i18n.t('94bd113e7c'),
  40010003: i18n.t('e242d9844d'),
  40110002: i18n.t('321495498a'),
  40010008: i18n.t('321495498a'),
  40300001: i18n.t('321495498a'),
  40310002: i18n.t('94bd113e7c'),
  40310004: i18n.t('7703961444'),
  40310005: i18n.t('85d6dfb01c'),
  40010011: i18n.t('aa35fa807c'),
  40310008: i18n.t('6728034eac'),
  40010014: i18n.t('c99e7e8772'),
  40010015: i18n.t('c99e7e8772'),
  userNotLogin: i18n.t('11377326ac'),
  fileNotExists: i18n.t('4c5c817619'),
  converting: i18n.t('b8b1ab19a3'),
  lightLinkNotExist: i18n.t('69570a01ee'),
  processing: i18n.t('ce6559062c'),
  // 下面错误码仅占位，可不翻译
  linkClosed: i18n.t('05bd98be76'),
  notCompanyMember: i18n.t('6728034eac'),
  permissionDenied: i18n.t('c48dea50b2'),
  lightlinkForbid: i18n.t('780dc2da0a'),
  ErrForbidDownloadLinkFile: i18n.t('bdeb76266c'),
  installPackageBanDownloading: i18n.t('f99e7e8772')
}
export default function getError(code, val = {}) {
  let error = errorMap[code]
  if (error) {
    forEach(val, (val, key) => {
      error = error.replace(new RegExp(`#{${key}}`, 'g'), val)
    })
    return error
  }
  return error
}
